import React, { useEffect } from 'react';
import { X, Edit2, Phone, Star, Truck } from 'lucide-react';
import './CourierDetailsPanel.css';

export default function CourierDetailsPanel({ isOpen, onClose, courierData, onEdit }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !courierData) return null;

  const getStatusClass = (status) => {
    switch(status?.toLowerCase()) {
      case 'active': return 'status-active';
      case 'on-break': return 'status-on-break';
      case 'offline': return 'status-offline';
      default: return '';
    }
  };

  return (
      <>
        <div className="panel-backdrop" onClick={onClose}></div>
        <div className="courier-details-panel">
          <div className="panel-header">
            <h2>Courier Details</h2>
            <div className="panel-header-actions">
              <button className="panel-edit-btn" onClick={() => onEdit && onEdit(courierData)} title="Edit Courier">
                <Edit2 size={18} />
                <span>Edit</span>
              </button>
              <button className="panel-close-btn" onClick={onClose}>
                <X size={20} />
              </button>
            </div>
          </div>

          <div className="panel-content">
            <div className="panel-courier-profile">
              <div className="courier-avatar-large">
                {courierData.name?.charAt(0) || 'C'}
              </div>
              <div className="courier-title-info">
                <h3>{courierData.name}</h3>
                <span className={`status-badge ${getStatusClass(courierData.status)}`}>
                  {courierData.status?.toUpperCase()}
                </span>
              </div>
            </div>

            <div className="panel-grid-2">
              <div>
                <p className="panel-label">Courier ID</p>
                <p className="panel-value-bold">{courierData.id}</p>
              </div>
              {/* FIX: Removed broken // BEFORE // AFTER comments from JSX.
                  FIX: Using courierData.plateNo (consistent with how CouriersListPage maps it)
                  instead of courierData.plate_no which would always be undefined. */}
              <div>
                <p className="panel-label">Vehicle</p>
                <div className="panel-icon-row">
                  <Truck size={16} className="panel-icon" />
                  <p className="panel-value-bold">{courierData.vehicle || 'Unassigned'}</p>
                </div>
                {courierData.plateNo && (
                    <p className="panel-text" style={{ marginTop: '4px', marginLeft: '24px', color: '#6b7280', fontSize: '13px' }}>
                      {courierData.plateNo}
                    </p>
                )}
              </div>
            </div>

            <div className="panel-section">
              <h3 className="panel-section-title">Contact Information</h3>
              <div className="panel-contact-details">
                {courierData.phone && (
                    <div className="panel-icon-row">
                      <Phone size={16} className="panel-icon" />
                      <p className="panel-text">{courierData.phone}</p>
                    </div>
                )}
              </div>
            </div>

            <div className="panel-section">
              <h3 className="panel-section-title">Performance</h3>
              <div className="panel-grid-2">
                <div className="performance-stat">
                  <p className="panel-label">Total Deliveries</p>
                  <p className="panel-value-large">{courierData.deliveries || 0}</p>
                </div>
                <div className="performance-stat">
                  <p className="panel-label">Rating</p>
                  <div className="rating-value-row">
                    <Star size={20} className="star-icon" fill="currentColor" />
                    <p className="panel-value-large">{courierData.rating || '0.0'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
}